  <template >
<div>

 <div v-role="est"  class="formPosition"    >
 <template>
  <v-container class="grey lighten-5">

      <v-col >

<div  class="text-center">

    <h5 style="float:left;">Nossos Contactos:</h5><br>
    <span style="float:left;">948 105 702</span><br>
   <span style="float:left;">contacto.softline@gmail.com</span>
<div   :class="this.$store.state.classMessage" >{{this.$store.state.textMessage}}</div>

    <span  class="hidden-md-and-up pb-0" style="font-size:14px">  {{  instituicaodescricao }}</span> <br>
    <span   style="font-size:14px" > Anolectivo:  {{  anolectivo}}</span><br>
    <span  style="font-size:14px">   {{loggedUserName}} {{role}}  </span>

    <br>
    <br>
    <h2 style="color:red;"> APLICAÇÃO APENAS DE TESTE </h2>
    <h3 style="color:red;"> Os dados aqui inseridos ,serão posteriormente descartados </h3>
    <br>
    <br>
    <h4>   NAVEGADORES SUPORTADOS</h4>
    <ul style="list-style:none;">
      <li>Google Chrome</li>
      <li>Firefox</li>
      <li>Internet Explore11 ou acima</li>
      <li>Safari 10 ou acima</li>
    </ul>
  </div>
      </v-col>

  </v-container>
</template>
   </div>
</div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
// const message = require('../config/messages')
export default {

  data: () => ({

  }),

  computed: {

    instituicaodescricao () {
      return ls.get('instituicaodescricao')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },
    loggedUserName () {
      return ls.get('nomeUsuario')
    },
    role () {
      let rl = ''
      if (ls.get('role') === 'ROLE_ADM') {
        rl = 'logado como Administrador'
      } else if (ls.get('role') === 'ROLE_PROF') {
        rl = 'logado como Professor'
      } else if (ls.get('role') === 'ROLE_FUNC') {
        rl = 'logado como Funcionario'
      } else if (ls.get('role') === 'ROLE_EST') {
        rl = 'logado como Estudante'
      } else if (ls.get('role') === 'ROLE_DIR') {
        rl = 'logado como Director'
      } else if (ls.get('role') === 'ROLE_COOR') {
        rl = 'logado como Coordenador de Curso'
      } else if (ls.get('role') === 'ROLE_PED') {
        rl = 'logado como Sub-Director Pedagógico'
      } else if (ls.get('role') === 'ROLE_PWR') {
        rl = 'logado como Usuário com Superiores Previlêgios'
      } else if (ls.get('role') === 'ROLE_DIRCOL') {
        rl = 'logado como Director de Colégio'
      }
      return rl
    }
  },

  created () {
    // this.GetUserLocation()
  //  this.LoginlogsInsert('longitude', 'latitude')

  },

  methods: {

    async  GetUserLocation () {
      this.$getLocation()
        .then(coordinates => {
          let location = Object.values(coordinates)

          let valores = location.toString().split(',')
          let latitude = valores[0]
          let longitude = valores[1]

          this.LoginlogsInsert(longitude, latitude)
        })
    },

    async   ObterDataTimeRemote () {
      var today = new Date()
      var day = today.getDate() + ''
      var month = (today.getMonth() + 1) + ''
      var year = today.getFullYear() + ''
      var hour = today.getHours() + ''
      var minutes = today.getMinutes() + ''
      var seconds = today.getSeconds() + ''

      day = checkZero(day)
      month = checkZero(month)
      year = checkZero(year)
      hour = checkZero(hour)
      minutes = checkZero(minutes)
      seconds = checkZero(seconds)

      return (year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds)

      function checkZero (data) {
        if (data.length === 1) {
          data = '0' + data
        }
        return data
      }
    },

    async LoginlogsInsert (longitude, latitude) {
      let dtt = await this.ObterDataTimeRemote()
      const params =
      {
        loginUpdate: 0,
        username: ls.get('idPessoa'),
        nome: ls.get('nomeUsuario'),
        datain: dtt,
        dataout: '',
        autor: ls.get('nomeUsuario'),
        loginpkCode: ls.get('uuid'),
        instituicao: ls.get('instituicaodescricao'),
        role: ls.get('role'),
        latitude: 'latitude',
        longitude: 'longitude'

      }

      // consumindo a API
      try {
        // eslint-disable-next-line no-unused-vars
        let msg = await axios
          .post('/InsertOrUpdateLoginLogs', params)
          .then(res => res.data)
      } catch (error) {

      }
    }
  }
}
</script>
